import { render } from "./ObjectLink.vue?vue&type=template&id=645df20f&scoped=true"
import script from "./ObjectLink.vue?vue&type=script&lang=js"
export * from "./ObjectLink.vue?vue&type=script&lang=js"

import "./ObjectLink.vue?vue&type=style&index=0&id=645df20f&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645df20f"]])

export default __exports__